import { useStaticQuery, graphql } from 'gatsby'

export const queryIndex = () => {
  const query = useStaticQuery(
    graphql`
      {
        allSanityProduct {
          edges {
            node {
              _rawContent(resolveReferences: {maxDepth: 9})
            }
          }
        }
      }
    `
  )
  return query.allSanityProduct.edges
}
